// src/layout/Dashboard/Drawer/DrawerContent/Navigation/index.jsx
// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import (existing)
import NavGroup from './NavGroup';
import NavCollapse from './NavCollapse';
import NavItem from './NavItem';

import useMenuItems from '../../../../../menu-items/useMenuItems'; // adjust if needed

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const { items } = useMenuItems();

  const safeItems = Array.isArray(items) ? items : [];

  if (safeItems.length === 0) {
    // optional: show nothing until menus available
    return <Box sx={{ pt: 2 }} />;
  }

  const navGroups = safeItems.map((item) => {
    if (!item) return null;

    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;

      case 'collapse':
        return <NavCollapse key={item.id} menu={item} level={1} />;

      case 'item':
        return <NavItem key={item.id} item={item} level={1} />;

      default:
        return null;
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
